import { createContext, useContext } from 'react';

interface TabsWidgetContextValue {
  selectedValue: string;
}

const TabsWidgetContext = createContext<TabsWidgetContextValue | null>(null);

export { TabsWidgetContext };

export function useTabsWidgetContext(): TabsWidgetContextValue {
  const ctx = useContext(TabsWidgetContext);
  if (!ctx) {
    throw new Error('TabsWidget.Content must be rendered inside a TabsWidget.');
  }
  return ctx;
}
